import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Menu, message, Modal, Spin } from "antd";
import QueueAnim from "rc-queue-anim";
import enquire from "enquire.js";

import moment from "moment";

import { DESKTOP_DOWN } from "../../config/mediaQueries";

import { generalActions } from "./../../redux/actions";

import { departmentsService } from "./../../redux/services";

import {
	UIAvatarLabel,
	UIPageListing,
} from "./../../components";

import { kpisAfterToggle, statusKpis } from "./../../components/KpiCards";

import ModalShow from "./show";
import ModalFilters from "./filters";
import ModalEdit from "./edit";
import ModalCreate from "./create";

const config = {
	title: "Departamentos",
	subtitle: "Gerencie os departamentos da sua empresa.",
	icon: <i className="fal fa-sitemap" />,
	infoBanner: {
		icon: <i className="fal fa-info-circle" />,
		title: "Sobre os departamentos",
		description: "Os departamentos organizam os funcionários dentro de cada empresa e podem ser usados como filtro em relatórios, lançamentos e regras de ponto.",
	},
	permissionPrefix: "departamentos",
	list: "departamentos",
	searchPlaceholder: "Buscar por nome do departamento",
	orders: [
		{
			label: "Mais recentes",
			field: "id",
			sort: "desc",
			default: true,
		},
		{
			label: "Mais antigos",
			field: "id",
			sort: "asc",
		},
		{
			label: "Nome A|Z",
			field: "nome",
			sort: "asc",
		},
		{
			label: "Nome Z|A",
			field: "nome",
			sort: "desc",
		},
	],
};

class Index extends Component {
	constructor(props) {
		super(props);

		const defaultOrder = config.orders.find(o => o.default);

		this.state = {
			isLoading: false,
			listType: "list",
			data: [],
			pagination: {
				current: 1,
				pageSize: 20,
				total: 0,
			},
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort: defaultOrder.sort,
			search: new URLSearchParams(props.location.search).get("search") || "",
			// Actions
			createModalVisible: false,
			editModalVisible: false,
			showModalVisible: false,
			exportModalVisible: false,
			filtersModalVisible: false,
			activeLoadings: [],
			isExporting: false,
			passwordModalVisible: false,
			// Images
			imagePreviewVisible: false,
			imagePreviewImage: "",
			// Media queries
			desktopDown: false,
			// Filters
			filters: {
				is_active: 1,
				tipo_contrato: null,
				empresa_uuid: null,
				state_id: null,
				sem_contratos: null,
			},
			kpis: null,
		};
	}

	static getDerivedStateFromProps(props, state) {
		if (props.listType && state.listType !== props.listType) {
			return {
				listType: props.listType
			};
		}

		return null;
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll(true);

		// Listen Media Querie sideBar
		enquire.register(DESKTOP_DOWN, {
			match: () => {
				this.setState({
					desktopDown: true,
				})
			},
			unmatch: () => {
				this.setState({
					desktopDown: false,
				})
			}
		});
	};

	componentWillUnmount() {
		// Unlisten Media Querie sideBar
		enquire.unregister(DESKTOP_DOWN);
	};

	menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => this.showOpen(item)}>
					<i className="fal fa-file" />Visualizar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="edit">
				<a onClick={() => this.editOpen(item)}>
					<i className="fal fa-pen" />Editar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="activate/deactivate">
				<a onClick={() => this.activateDeactivate(item, item.ativo != 1)}>
					{item.ativo == 1 ? <i className="fal fa-ban" /> : <i className="fal fa-check-circle" />}{item.ativo == 1 ? "Desativar" : "Ativar"}
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	columns = () => {
		const listTypeCard = this.state.listType === "card";
		return [
			{
				title: "Departamento",
				render: (item) => (
					<UIAvatarLabel id={item.id} name={item.nome} icon={<i className="fal fa-sitemap" />} square />
				),
			},
			{
				title: "Número da folha",
				className: "card-block-width-2",
				width: 160,
				render: (item) => {
					const numeroFolha = item.numero_folha ?? "-";

					return listTypeCard ? (
						<Fragment>
							<i className="fal fa-hashtag" style={{ marginRight: 5 }} />{numeroFolha}
						</Fragment>
					) : numeroFolha;
				},
			},
			{
				title: "Data do Cadastro",
				className: "datetime card-block-width-2",
				width: 160,
				render: (item) => {
					if (listTypeCard) {
						return (
							<Fragment>
								<i className="fal fa-plus-circle" style={{ marginRight: 5 }} />{moment(item.created_at).format("DD/MM/YYYY")}
							</Fragment>
						);
					}

					return moment(item.created_at).format("DD/MM/YYYY");
				}
			},
			{
				title: "Status",
				className: "active no-ellipsis",
				width: 90,
				render: (item) => this.state.activeLoadings.indexOf(item.uuid) !== -1 ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : (
					<span className={`status-tag ${item.ativo == 1 ? "status-tag-success" : "status-tag-error"}`}>
						<i className="status-tag-dot" />
						{item.ativo == 1 ? "Ativo" : "Inativo"}
					</span>
				)
			},
			{
				title: "Ações",
				className: "actions no-ellipsis",
				visible: this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".edit") || this.props.permissions.includes(config.permissionPrefix + ".delete"),
				render: (item) => (
					<Dropdown overlay={this.menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon={<i className="fal fa-ellipsis-v" />} />
					</Dropdown>
				),
			},
		];
	};

	fetchGetAll = (init = false, exportItems = false) => {
		const { pagination, orderByField, orderBySort, search, filters } = this.state;
		if (exportItems) {
			this.setState({
				isExporting: true,
			});
		}
		else {
			this.setState({
				isLoading: true,
			});
		}

		const data = {
			orderBy: `${orderByField}:${orderBySort}`,
			search: search,
		};

		if (exportItems) {
			data.exportItems = true;
		}
		else {
			data.page = init ? 1 : pagination.current;
			data.limit = pagination.pageSize;
		}

		if (filters.empresa_uuid !== null) {
			data.empresa_uuid = filters.empresa_uuid;
		}

		if (filters.state_id !== null) {
			data.state_id = filters.state_id;
		}

		if (filters.revenda_id !== null) {
			data.revenda_id = filters.revenda_id;
		}

		if (filters.is_active !== null) {
			data.is_active = filters.is_active;
		}
		if (filters.tipo_contrato !== null) {
			data.tipo_contrato = filters.tipo_contrato;
		}

		if (filters.sem_contratos) {
			data.sem_contratos = 1;
		}

		if (filters.created_at) {
			data.created_at = [
				filters.created_at[0].clone().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
				filters.created_at[1].clone().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
			];
		}

		departmentsService.getAll(data)
			.then((response) => {
				if (exportItems) {
					this.setState({
						isExporting: false,
					});

					window.open(response.data.file_url, "_blank");
				}
				else {
					this.setState(state => ({
						isLoading: false,
						data: response.data.data,
						kpis: response.data.kpis ?? null,
						pagination: {
							...state.pagination,
							current: response.data.meta.current_page,
							total: response.data.meta.total,
						},
					}));
				}
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onStatusKpiChange = (status) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				is_active: status,
			},
		}), () => this.fetchGetAll(true));
	};

	// A contagem considera ativos e inativos, então o filtro limpa o status para a lista bater com o número
	onWithoutContractsKpiChange = () => {
		this.setState(state => ({
			filters: {
				...state.filters,
				sem_contratos: state.filters.sem_contratos ? null : 1,
				is_active: state.filters.sem_contratos ? state.filters.is_active : null,
			},
		}), () => this.fetchGetAll(true));
	};

	kpis = () => {
		const isWithoutContractsActive = !!this.state.filters.sem_contratos;

		return [
			...statusKpis({
				kpis: this.state.kpis,
				icon: <i className="fal fa-sitemap" />,
				title: "Total de departamentos",
				caption: "Departamentos cadastrados",
				status: this.state.filters.is_active,
				onStatusChange: this.onStatusKpiChange,
			}),
			{
				key: "without-contracts",
				tone: "amber",
				icon: <i className="fal fa-user-slash" />,
				title: "Sem funcionários",
				value: this.state.kpis?.sem_contratos ?? null,
				caption: "Sem contratos vinculados",
				onClick: this.onWithoutContractsKpiChange,
				active: isWithoutContractsActive,
			},
		];
	};

	onListTypeChange = (type) => {
		this.props.onChangeListType(type);
	};

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll();
		});
	};

	onOrderChange = (value) => {
		const defaultOrder = config.orders.find(o => `${o.field}:${o.sort}` === value);

		if (!defaultOrder) return null;

		this.setState(state => ({
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort: defaultOrder.sort,
		}), () => {
			this.fetchGetAll(true);
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if (!e.hasOwnProperty("type")) {
			const { search } = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if (search) {
					this.fetchGetAll(true);
				}
			});
		}
	};

	/**
	 * Show
	 *
	 * @param uuid
	 */
	showOpen = ({ uuid }, general_key) => {
		this.setState({ showModalVisible: true });

		// On open screen
		this.showScreen.onOpen(uuid, general_key);
	};

	showOnClose = () => {
		this.setState({ showModalVisible: false });
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = ({ uuid }) => {
		Modal.confirm({
			title: "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText: "Excluir",
			autoFocusButton: null,
			onOk: () => {
				return this.deleteConfirmed(uuid);
			}
		});
	};

	deleteConfirmed = (uuid) => {
		return departmentsService.destroy({ uuid })
			.then((response) => {
				// Fecth all
				this.fetchGetAll();
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({ createModalVisible: true });

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({ createModalVisible: false });
	};

	createOnComplete = () => {
		this.setState({ createModalVisible: false });
		// Fecth all
		this.fetchGetAll(true)
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({ uuid }) => {
		this.setState({ editModalVisible: true });

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	editOnClose = () => {
		this.setState({ editModalVisible: false });
	};

	editOnComplete = () => {
		this.setState({ editModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Password
	 */
	passwordOpen = (item) => {
		this.setState({ passwordModalVisible: true });

		// On open screen
		this.passwordScreen.onOpen(item);
	};

	passwordOnClose = () => {
		this.setState({ passwordModalVisible: false });
	};

	passwordOnComplete = () => {
		this.setState({ passwordModalVisible: false });

		Modal.success({
			title: "E-mail enviado!",
			content: "Foi enviado para o usuário sua nova senha.",
		});
	};

	/**
	 * Filter
	 */
	filtersOpen = () => {
		this.setState({ filtersModalVisible: true });

		// On open screen
		this.filtersScreen.onOpen({ ...this.state.filters });
	};

	filtersOnClose = () => {
		this.setState({ filtersModalVisible: false });
	};

	filtersOnComplete = (filters) => {
		this.setState({ filtersModalVisible: false });
		this.setState({
			filters: filters,
		}, () => {
			// Fecth all
			this.fetchGetAll(true);
		});
	};

	/**
	 * Active/Desactive
	 *
	 * @param {number} uuid
	 * @param {boolean} activate
	 */
	activateDeactivate = ({ uuid }, activate) => {
		const { activeLoadings } = this.state;

		if (activeLoadings.indexOf(uuid) === -1) {
			activeLoadings.push(uuid);
		}

		this.setState({
			activeLoadings: activeLoadings,
		});

		departmentsService.edit({ uuid, ativo: activate })
			.then((response) => {
				const newData = [...this.state.data];
				const index = newData.findIndex(item => uuid === item.uuid);

				if (index !== -1) {
					const item = newData[index];

					newData.splice(index, 1, {
						...item,
						ativo: response.data.data.ativo,
					});

					this.setState(state => ({
						data: newData,
						kpis: response.data.data.ativo === undefined ? state.kpis : kpisAfterToggle(state.kpis, item.ativo == 1, response.data.data.ativo == 1),
					}));
				}

				message.success(activate ? "Departamento ativado." : "Departamento desativado.");
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			}).finally(() => {
				const { activeLoadings } = this.state;
				const index = activeLoadings.indexOf(uuid);

				if (index !== -1) {
					activeLoadings.splice(index, 1);

					this.setState({
						activeLoadings: activeLoadings,
					});
				}
			});
	};

	/**
	 * Image preview
	 */
	onImagePreviewClose = () => this.setState({ imagePreviewVisible: false });

	onImagePreview = (url) => {
		this.setState({
			imagePreviewImage: url,
			imagePreviewVisible: true,
		});
	};

	render() {
		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content fixed-header" key="1">
					<UIPageListing
						icon={config.icon}
						title={config.title}
						subtitle={config.subtitle}
						kpis={this.kpis()}
						infoBanner={config.infoBanner}
						onSearch={this.onSearch}
						onSearchChange={this.onSearchChange}
						onPaginationChange={this.onPaginationChange}
						onOrderChange={this.onOrderChange}
						onListTypeChange={this.onListTypeChange}
						onFiltersClick={this.filtersOpen}
						isLoading={this.state.isLoading}
						listType={this.state.listType}
						orderByField={this.state.orderByField}
						orderBySort={this.state.orderBySort}
						orders={config.orders}
						search={this.state.search}
						searchPlaceholder={config.searchPlaceholder}
						data={this.state.data}
						pagination={this.state.pagination}
						columns={this.columns()}
						showFilters={true}
						buttons={[
							{
								visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
								onClick: this.createOpen,
								title: "Incluir",
								icon: <i className="far fa-plus" />,
							},
							{
								visible: false, // TODO this.props.permissions.includes(config.permissionPrefix + ".export"),
								onClick: () => this.fetchGetAll(true, true),
								title: this.state.isExporting ? "Exportando" : "Exportar",
								icon: <i className="fal fa-file-export" />,
								loading: this.state.isExporting,
							},
						]}
					/>
				</div>
				<ModalCreate
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
				<ModalEdit
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalShow
					ref={el => this.showScreen = el}
					visible={this.state.showModalVisible}
					onClose={this.showOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>
				<Modal wrapClassName="modal-image" visible={this.state.imagePreviewVisible} centered footer={null} destroyOnClose={true} onCancel={this.onImagePreviewClose}>
					<img src={this.state.imagePreviewImage} />
				</Modal>
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType: state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
